module.exports = __webpack_public_path__ + "static/Short2-4621f5e027ce4cd3481bc89eedc247db.png";